var _rect, _rect2, _rect3, _rect4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAllPages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 125,
    viewBox: "0 0 92 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 60,
    rx: 6,
    fill: "#E9ECEF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    width: 44,
    height: 60,
    rx: 6,
    fill: "#E9ECEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 65,
    width: 44,
    height: 60,
    rx: 6,
    fill: "#E9ECEF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 65,
    width: 44,
    height: 60,
    rx: 6,
    fill: "#E9ECEF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllPages);
export default __webpack_public_path__ + "static/media/all-pages.2e5433f5514acd94fec31a413a32a54a.svg";
export { ForwardRef as ReactComponent };